export const nbsp = "\u00A0";

export const topFourLeagues = ["mlb", "nhl", "nba", "nfl"];

export const lineClampMap = {
  1: "cui-line-clamp-1",
  2: "cui-line-clamp-2",
  3: "cui-line-clamp-3",
  4: "cui-line-clamp-4",
};

export const textAlignMap = {
  "left": "",
  "center": "cui-text-center",
  "right": "cui-text-right"
}

const parseWomen = (name) => {
  let _name = (name?.includes(" (W)") ? name?.replace(" (W)", "") : name)?.toLowerCase();
  if (_name?.toLowerCase().includes("women")) _name = _name.replace(/[Ww]omens?$/, "").trim();
  return name;
}